export class Timer {
    private startTime: number;

    public constructor() {
        this.startTime = Date.now();
    }

    public getElapsedTime(): [number, number] {
        const elapsedMs: number = Date.now() - this.startTime;
        const totalSeconds: number = Math.floor(elapsedMs / 1000);
        const minutes: number = Math.floor(totalSeconds / 60);
        const seconds: number = totalSeconds % 60;
        return [minutes, seconds];
    }
}
